import React from "react";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@redux/dispatcher";
import { set as setProductComparisonSkuList } from "@redux/modules/value/productComparisonSkuList/productComparisonSkuList.module";
import { getProductComparisonSkuList } from "@redux/modules/value/productComparisonSkuList/productComparisonSkuList.selectors";

import Compare from "@components/Product/ECommerce/compare/compare.component";

type ComparisonProps = {
    sku: string;
    className?: string;
};

const Comparison = ({ sku, className }: ComparisonProps) => {
    const dispatch = useThunkDispatch();
    const productCompareList = useSelector(getProductComparisonSkuList);

    const onSetProductComparisonSku = (skuList: string[]) => {
        dispatch(setProductComparisonSkuList(skuList));
    };

    return (
        <Compare
            className={className}
            sku={sku}
            productComparisonSkuList={productCompareList || []}
            onSetProductComparisonSkuList={onSetProductComparisonSku}
        />
    );
};

export default Comparison;
